import { Injectable, Injector } from '@angular/core';

import { IPaymentGatewayProvider } from './payment-gateway-provider';
import { DataTransGatewayService } from './datatrans-gateway.service';
import { PaySafeGatewayService } from './paysafe-gateway.service';
import { GATEWAY_PAYMENT_CODE } from './payment-gateway-constant';
import { EcommpayGatewayService } from './ecommpay-gateway.service';
import { GoCardlessGatewayService } from './gocardless-gateway.service';

@Injectable({
    providedIn: 'root'
})
export class PaymentGatewayFactory {

    constructor(private injector: Injector
    ) {
    }

    public create(gatewayProviderCode: string): IPaymentGatewayProvider {
        switch (gatewayProviderCode.toUpperCase()) {
            case GATEWAY_PAYMENT_CODE.DATATRANS:
                return this.injector.get(DataTransGatewayService);
            case GATEWAY_PAYMENT_CODE.PAYSAFE:
                return this.injector.get(PaySafeGatewayService);   
            case GATEWAY_PAYMENT_CODE.ECOMMPAY:
                return this.injector.get(EcommpayGatewayService);
            case GATEWAY_PAYMENT_CODE.GOCARDLESS:
                return this.injector.get(GoCardlessGatewayService);
        }
        return null;
    }
}